import { render, staticRenderFns } from "./MyDormServices.vue?vue&type=template&id=7784fd9d&scoped=true&"
import script from "./MyDormServices.vue?vue&type=script&lang=js&"
export * from "./MyDormServices.vue?vue&type=script&lang=js&"
import style0 from "./MyDormServices.vue?vue&type=style&index=0&id=7784fd9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7784fd9d",
  null
  
)

export default component.exports